import { render, staticRenderFns } from "./LoadPDK.vue?vue&type=template&id=066178a8&scoped=true"
import script from "./LoadPDK.vue?vue&type=script&lang=js"
export * from "./LoadPDK.vue?vue&type=script&lang=js"
import style0 from "./LoadPDK.vue?vue&type=style&index=0&id=066178a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066178a8",
  null
  
)

export default component.exports